import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import AdminAuthGuard from './admin/AdminAuthGuard';
import AdminErrorBoundary from './admin/AdminErrorBoundary';
import AdminHome from './admin/AdminHome';
import AdminSOSearch from './admin/scheduled-offerings/SOSearch';
import SOCreate from './admin/scheduled-offerings/SOCreate';
import SOEdit from './admin/scheduled-offerings/SOEdit';
import SessionAdd from './admin/sessions/SessionAdd';
import SessionManage from './admin/sessions/SessionManage';
import AttendeeImport from './admin/import/AttendeeImportNew';
import ImportTemplates from './admin/import/ImportTemplates';
import ExternalSurveyImport from './admin/import/ExternalSurveyImport';
import AdminClients from './admin/AdminClients';
import { 
  MaterialsHome,
  ProgramSelector,
  ProgramMaterials,
  SessionMaterials,
  BulkOperations,
  MaterialsAnalytics
} from './admin/materials';


const AdminDashboard = () => {
  return (
    <AdminErrorBoundary>
      <AdminAuthGuard>
        <AdminLayout>
            <Routes>
              {/* Default redirect to dashboard */}
              <Route path="/" element={<Navigate to="/admin/dashboard" />} />
              
              {/* Protected lazy-loaded admin routes */}
              <Route path="/dashboard" element={<AdminHome />} />
              
              {/* Scheduled Offerings routes */}
              <Route path="/scheduled-offerings/search" element={<AdminSOSearch />} />
              <Route path="/scheduled-offerings/create" element={<SOCreate />} />
              <Route path="/scheduled-offerings/:id/edit" element={<SOEdit />} />
              
              {/* Sessions routes */}
              <Route path="/sessions/add" element={<SessionAdd />} />
              <Route path="/sessions/manage" element={<SessionManage />} />
              
              {/* Import routes */}
              <Route path="/import/attendees" element={<AttendeeImport />} />
              <Route path="/import/templates" element={<ImportTemplates />} />
              <Route path="/import/surveys" element={<ExternalSurveyImport />} />
              
              {/* Clients route */}
              <Route path="/clients" element={<AdminClients />} />
              
              {/* Materials Management routes */}
              <Route path="/materials" element={<MaterialsHome />} />
              <Route path="/materials/analytics" element={<MaterialsAnalytics />} />
              <Route path="/materials/bulk-operations" element={<BulkOperations />} />
              <Route path="/materials/programs/:programId" element={<ProgramSelector />} />
              <Route path="/materials/programs/:programId/materials" element={<ProgramMaterials />} />
              <Route path="/materials/programs/:programId/sessions/:sessionId" element={<SessionMaterials />} />
              
              {/* Catch-all redirect */}
              <Route path="*" element={<Navigate to="/admin/dashboard" />} />
            </Routes>
        </AdminLayout>
      </AdminAuthGuard>
    </AdminErrorBoundary>
  );
};

export default AdminDashboard;